var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTailwind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 481,
    viewBox: "0 0 800 481",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 0.375C293.333 0.375 226.667 53.7083 200 160.375C240 107.042 286.667 87.0417 340 100.375C370.43 107.982 392.179 130.058 416.253 154.495C455.471 194.302 500.861 240.375 600 240.375C706.667 240.375 773.333 187.042 800 80.375C760 133.708 713.333 153.708 660 140.375C629.57 132.768 607.821 110.692 583.747 86.255C544.529 46.4476 499.139 0.375 400 0.375ZM200 240.375C93.3333 240.375 26.6667 293.708 0 400.375C40 347.042 86.6667 327.042 140 340.375C170.43 347.982 192.179 370.058 216.253 394.495C255.471 434.302 300.861 480.375 400 480.375C506.667 480.375 573.333 427.042 600 320.375C560 373.708 513.333 393.708 460 380.375C429.57 372.768 407.821 350.692 383.747 326.255C344.529 286.448 299.139 240.375 200 240.375Z",
    fill: "url(#paint0_linear_248_5)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_248_5",
    x1: -2222.22,
    y1: 15360.4,
    x2: 66870.9,
    y2: 55197.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38BDF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38BDF8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTailwind);
export default __webpack_public_path__ + "static/media/tailwind.e4a81b0cc425d3e9c5826dbbd6aa3802.svg";
export { ForwardRef as ReactComponent };